/**
 * ViewerContext
 *
 * Provides Cesium viewer instance to all components
 */

import { createContext, useContext } from 'react';
import type { Viewer as CesiumViewer } from 'cesium';

interface ViewerContextType {
  viewer?: CesiumViewer;
}

const ViewerContext = createContext<ViewerContextType | undefined>(undefined);

export function ViewerProvider({
  viewer,
  children,
}: {
  viewer?: CesiumViewer;
  children: React.ReactNode;
}) {
  return (
    <ViewerContext.Provider value={{ viewer }}>
      {children}
    </ViewerContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useViewer(): ViewerContextType {
  const context = useContext(ViewerContext);
  if (context === undefined) {
    throw new Error('useViewer must be used within ViewerProvider');
  }
  return context;
}
